export default __webpack_public_path__ + "static/media/logo-small.b45b7454.svg";